'use strict';

var positions = require('../positions'),

    graphic = {
        480:  {},
        576:  {},
        720:  {},
        1080: {}
    };

graphic[480][positions.leftTop] = {
    width: 300,
    height: 170,
    x: 80,
    y: 70
};

graphic[480][positions.rightTop] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 900,
    y: 70
};

graphic[480][positions.rightBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 900,
    y: 480
};

graphic[480][positions.leftBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 80,
    y: 480
};

graphic[576][positions.leftTop] = {
    width: 350,
    height: 194,
    x: 110,
    y: 54
};
graphic[576][positions.rightTop] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: 820,
    y: 54
};
graphic[576][positions.rightBottom] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: 820,
    y: 373
};
graphic[576][positions.leftBottom] = {
    width: graphic[576][positions.leftTop].width,
    height: graphic[576][positions.leftTop].height,
    x: 110,
    y: 373
};

graphic[720][positions.leftTop] = {
    width: 300,
    height: 170,
    x: 80,
    y: 70
};
graphic[720][positions.rightTop] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: 900,
    y: 70
};
graphic[720][positions.rightBottom] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: 900,
    y: 480
};
graphic[720][positions.leftBottom] = {
    width: graphic[720][positions.leftTop].width,
    height: graphic[720][positions.leftTop].height,
    x: 80,
    y: 480
};

graphic[1080] = graphic[720];


module.exports = graphic;
